export default class PasswordRecoveryController {
  constructor($state, PasswordRecoveryService, Notification, $translate) {
    this.state = $state;
    this.service = PasswordRecoveryService;
    this.recoveryToken = $state.params.token;
    this.notify = Notification;
    this.trans = $translate.instant;
  }

  $onInit(){
    this.subscriptions = [];

    this.password = '';
    this.confirmPassword = '';
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  changePassword(){
    const _ = this.trans;
    if (this.password === this.confirmPassword){
      this.subscriptions.push(
        this.service.changePassword(this.password, this.recoveryToken).subscribe(
          (data) => {
            this.state.go('recoverySuccess');
          },
          (err) => {
            console.log(err);
          }
        )
      );
    } else {
      this.notify.warning(_('Las contraseñas deben coincidir'));
    }
  }
}

 PasswordRecoveryController.$inject = ['$state', 'PasswordRecoveryService', 'Notification', '$translate'];



// WEBPACK FOOTER //
// ./src/app/pages/password-recovery/password-recovery.controller.js